import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const SedesView = lazy(() => import('../../container/crud/sedes/Index'));
const SedesAdd = lazy(() => import('../../container/crud/sedes/Add'));


const ProfileRoute = () => {
  // console.log("*****ProfileRoutes*****");
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/view`} component={SedesView} />
      <Route path={`${path}/add`} component={SedesAdd} />
      <Route exact path={`${path}/edit/:id`} component={SedesAdd} />
    </Switch>
  );
};

export default ProfileRoute;
